{
  "certificates": {
    "kpiConnector": "PKI-Konnektor",
    "trustore": "Truststore",
    "s4Device": "S4-Geräte",
    "s4ToolsApp": "S4-Tools-Apps",
    "s4ManagerApp": "S4-Manager-Apps",
    "s4ViewApp": "S4-Anzeige-Apps",
    "sg4000": "SG4000-Apps",
    "requiredFields": "Felder mit einem * sind Pflichtfelder.",
    "delayInfo": "Der automatische Verlängerungszeitraum definiert den Zeitraum vor dem Ablaufdatum des Zertifikats, ab dem die automatische Einleitung des Zertifikatsverlängerungsprozesses ausgelöst wird.",
    "delayPlaceholder": "Verzögerung der automatischen Verlängerung",
    "delayPlaceholderCustom": "Verzögerung der automatischen Verlängerung (in Tagen)",
    "pollingPlaceholder": "Abfragehäufigkeit (Minuten)",
    "pollingInfoDevice": "Die Abfragehäufigkeit entspricht der Verzögerung zwischen 2 Austauschvorgängen zwischen LX CONNECT und dem Gerät.",
    "pollingInfoApplication": "Die Abfragehäufigkeit entspricht der Verzögerung zwischen 2 Austauschvorgängen zwischen LX CONNECT und der Anwendung.",
    "autoActivationLabel": "Automatische Aktivierung",
    "autoActivationAction": "Aktivieren",
    "autoActivationInfoApplication": "Die automatische Aktivierung ermöglicht es, die Anwendung bei der Bereitstellung zu aktivieren.",
    "autoActivationInfoDevice": "Die automatische Aktivierung ermöglicht es, das Gerät bei der Bereitstellung zu aktivieren.",
    "title": "Zertifikate"
  },
  "firmware": {
    "title": "Firmware",
    "firmwareManagement": "Firmware-Verwaltung"
  },
  "users": {
    "title": "Benutzer",
    "activeDirectory": "Active Directory"
  },
  "application": {
    "title": "Anwendungsparameter",
    "smtpServor": "SMTP-Server",
    "feelAndIdentity": "Erscheinungsbild und Identität"
  },
  "applicationMgt": {
    "title": "Anwendungen",
    "applicationManagement": "Anwendungsverwaltung"
  },
  "usersPreference": {
    "title": "Benutzereinstellungen",
    "userParams": "Benutzerparameter"
  },
  "technicalVersion": {
    "label": "Technische Version:",
    "unknown": "unbekannt"
  },
  "version": {
    "label": "Version:",
    "unknown": "unbekannt"
  },
  "platformMgt": {
    "title": "Plattform",
    "about": "Info"
  },
  "deviceConfiguration": "Geräteparametrierung"
}
